import { render } from "./AddProfilePicture.vue?vue&type=template&id=f45d1dda"
import script from "./AddProfilePicture.vue?vue&type=script&lang=js"
export * from "./AddProfilePicture.vue?vue&type=script&lang=js"

import "./AddProfilePicture.vue?vue&type=style&index=0&id=f45d1dda&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__